import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import * as XLSX from 'xlsx';

const PurchaseOrderReport = () => {

    const [reportrange, setReportrange] = useState('');
    const [dates, setDates] = useState([null, null]);
    const [reportDate, setReportDate] = useState('');
    const [inventoryReport, setInventoryReport] = useState([]);
    const accessToken = localStorage.getItem('accessToken');
    const salesOrderRef = useRef(null);

    const handleDateChange = (value) => {
        setDates(value);
    };

    const fetchReport = (startDate, endDate) => {
        const $table = $(salesOrderRef.current);
        const searchValue = $('#searchValue').val();

        // Destroy any existing DataTable instance to reinitialize with new data
        if ($.fn.DataTable.isDataTable($table)) {
            $table.DataTable().destroy();
        }

        // Initialize the DataTable with the new date range
        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.API_URL}/report/purchase_order_report`,
                type: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                data: function (d) {
                    return $.extend({}, d, {
                        draw: d.draw,
                        start: d.start,
                        length: d.length,
                        searchValue: searchValue,
                        reportrange: reportrange,
                        authorization: `Bearer ${accessToken}`,
                    });
                },
                dataSrc: function (json) {
                    if (json && json.data && Array.isArray(json.data)) {
                        setInventoryReport(json.data);
                    }

                    return Array.isArray(json.data) ? json.data : [];
                },
            },
            language: {
                paginate: {
                    first: 'First',
                    last: 'Last',
                    next: 'Next',
                    previous: 'Previous',
                },
                search: 'Search:',
            },
            columns: [
                { data: 'code' },
                { data: 'name' },
                {
                    data: 'type',
                    render: function (data, type, row) {
                        return data === "1" ? "BOX" : "PIECE";
                    }
                },
                { data: 'cost' },
                { data: 'price' },
                { data: 'purchase_box_qty' }
            ],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5], // Only 6 columns: 0-5
                    orderable: false
                }
            ],
            pageLength: 50,
        });
    };

    useEffect(() => {
        fetchReport();
    }, [reportrange]);

    const searchFormData = (selectedDates) => {
        let startDate = selectedDates[0] ? format(selectedDates[0], 'dd/MM/yyyy') : '';
        let endDate = selectedDates[1] ? format(selectedDates[1], 'dd/MM/yyyy') : '';
        // Convert them to 'MM/dd/yyyy' format for further use
        let formattedStartDate = selectedDates[0] ? format(selectedDates[0], 'MM/dd/yyyy') : '';
        let formattedEndDate = selectedDates[1] ? format(selectedDates[1], 'MM/dd/yyyy') : '';
        setReportrange(formattedStartDate ? formattedStartDate + ' - ' + formattedEndDate : '');
    };

    const exportToExcel = () => {
        // Use the latest inventoryReport state for export
        const exportData = inventoryReport.map(row => ({
            Code: row.code,
            Name: row.name,
            Type: row.type === "1" ? "BOX" : "PIECE",
            Cost: row.cost,
            Price: row.price,
            // Uncomment if you want to include these:
            // "Total Box Qty": row.total_box_qty,
            // "Total Piece Qty": row.total_piece_qty,
            "Purchase Box Qty": row.purchase_box_qty
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "PurchaseOrderReport");
        XLSX.writeFile(wb, "PurchaseOrderReport.xlsx");
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
                            <Link to="/reports/inventory_sales_report">Reports</Link>
                            <Link to="/reports/inventory_sales_report">Purchase report</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-container position-relative">
                <div className="container-fluid">
                    <div className="row purchase-order-report-filter">
                        {/* <label class="col-sm-3" style={{ marginBottom: '5px' }} ><b>Select Date</b></label> */}
                        <div class="col-sm-9">
                            <CommonDatePicker
                                value={dates}
                                showOneCalendar
                                // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                // onChange={handleDateChange}
                                onChange={(value) => {
                                    setDates(value);
                                    if (value && value[0] && value[1]) {
                                        searchFormData(value);
                                    }
                                }}
                                format="dd/MM/yyyy"
                                character=" - "
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div className="col-sm-3">
                            <button className="acceptbtn" onClick={exportToExcel} style={{ marginBottom: 10 }}>
                                Export
                            </button>
                        </div>
                    </div>

                    <div className="dashboard">

                        <div className="verical-scrl-wrapper common-table autoheight-table inventory-sales-report" id="style-3">
                            <table ref={salesOrderRef} className="table table-bordered resizable" id="inventorySalesReport">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Cost</th>
                                        <th>Price</th>
                                        <th>Purchase Box Qty</th>
                                    </tr>
                                </thead>
                                <tbody>

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    );

}

export default PurchaseOrderReport;
